export function extractErrorMessage(error: any): string {
  // 1. error.data.error_message[]
  if (
    error?.data?.error_message &&
    Array.isArray(error.data.error_message)
  ) {
    return error.data.error_message.join('\n');
  }

  // 2. error.data.error + optional path
  if (typeof error?.data?.error === 'string') {
    const path = error.data.path ? ` (по пути: ${decodeURIComponent(error.data.path)})` : '';
    return `${error.data.error}${path}`;
  }

  // 3. FETCH_ERROR
  if (error?.status === 'FETCH_ERROR') {
    return error.error || 'Ошибка соединения с сервером';
  }

  // 4. Стандартный Error объект
  if (error instanceof Error) {
    return error.message;
  }

  // 5. Строка как ошибка
  if (typeof error === 'string') {
    return error;
  }

  // 6. Что-то неизвестное
  return 'Произошла неизвестная ошибка';
}
